var presentsWereChanged = false,
    presentsInitialized = false;

function checkPresentsCount($list) {
    var maxCount = $list.attr('data-max'),
        checkedCount = 0;

    $list.find('.ui-spinner-input').each(function () {
        checkedCount += parseInt($(this).val());
    });

    $list.find('.ui-spinner-input').each(function () {
        var maxValue = maxCount - checkedCount,
            maxStock = $(this).attr('data-stock'),
            actualValue = $(this).val();

        var newValue = parseInt(actualValue) + parseInt(maxValue);

        if (newValue > parseInt(maxStock)) {
            newValue = maxStock;
        }

        $(this)
            .attr('value', actualValue)
            .attr('max', newValue)
            .spinner('option', 'max', newValue);

        if (newValue == 0) {
            $(this)
                .prop('disabled', true)
                .spinner('disable');
        } else {
            $(this)
                .prop('disabled', false)
                .spinner('enable');
        }
    });
};

$(function () {
    $(document).on('shown.bs.modal', '#up-sell, #present-modal', function () {
        var $form = $('#presentForm');

        quantity_spinner(true);

        $('.presents__list').each(function () {
            checkPresentsCount($(this));
        });

        if ($form.length > 0 && !presentsInitialized) {
            $('body').on('change', '#presentForm .presents__list .c-form__input', function () {
                var $list = $(this).parents('.presents__list'),
                    maxStockMsg = $list.attr('data-msg'),
                    maxStock = $(this).attr('data-stock'),
                    actualValue = $(this).val(),
                    notifyMe = $(this).attr('data-notify-me');

                if (parseInt(maxStock) == parseInt(actualValue)) {
                    if (parseInt(notifyMe) == 1) {
                        Eshop.alert(maxStockMsg, {type: 'warning'});
                    }

                    $(this).attr('data-notify-me', 1);
                } else {
                    $(this).attr('data-notify-me', 0);
                }

                checkPresentsCount($list);

                presentsWereChanged = true;
            });

            $('body').on('click', '#up-sell .c-btn--cart', function (event) {
                if (presentsWereChanged) {
                    var url = $(this).attr('href');

                    event.preventDefault();

                    // showPreloader();

                    Form.ajaxPost($form, function (data) {
                        window.location = url;
                    }, "json");
                }
            });

            $('body').on('click', '#present-modal .c-btn--cart', function (event) {
                event.preventDefault();

                if (presentsWereChanged) {
                    var url = $(this).attr('href');

                    // showPreloader();

                    Form.ajaxPost($form, function (data) {
                        window.location = url;
                    }, "json");
                } else {
                    $('#present-modal').modal('hide');
                }
            });

            presentsInitialized = true;
        }
    })

    $(document).on('hide.bs.modal', '#up-sell', function () {
        if (presentsWereChanged) {
            var $form = $('#presentForm');

            presentsWereChanged = false;

            Form.ajaxPost($form, function (data) { }, "json");
        }
    })
});
